import AccessibilityIcon from '@mui/icons-material/Accessibility';
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

class Footer extends React.Component {
  openCookieSettings = (e) => {
    e.preventDefault();
    if (typeof OneTrust !== 'undefined' && OneTrust.ToggleInfoDisplay)
      OneTrust.ToggleInfoDisplay();
  };

  render() {
    const currentYear = new Date().getFullYear();
    if (this.props.collapsed) {
      return (
        <div className="sidebar-footer">
          <div className="sidebar-footer-icons">
            <Link
              to="/app/account-settings"
              className="text-muted settings text-center"
            >
              <i className="icon-settings" />{' '}
            </Link>
            <Link
              to="/app/accessibility"
              className="mb-2 text-muted settings text-center"
            >
              <AccessibilityIcon fontSize="small" />{' '}
            </Link>
          </div>
        </div>
      );
    }
    return (
      <div className="sidebar-footer text-center">
        <Link
          to="/app/account-settings"
          className="mb-2 mt-1 text-muted settings text-center link"
          data-test="account-settings-button"
        >
          <i className="icon-settings" /> Account Settings
        </Link>
        <Link
          to="/app/accessibility"
          className="mb-2 text-muted settings text-center link"
        >
          <AccessibilityIcon fontSize="small" /> Accessibility
        </Link>
        <Row>
          <Col
            className="text-muted text-center mt-3 p-0"
            style={{
              whiteSpace: 'nowrap',
            }}
          >
            &copy; {currentYear} Kaplan North America, LLC.
            <br />
            All rights reserved.{' '}
            <a
              className="ot-sdk-show-settings"
              style={{
                cursor: 'pointer',
                color: '#007bff',
                display: 'block',
              }}
              onClick={this.openCookieSettings}
            >
              Cookies Settings
            </a>
            <a
              href="https://promotionwingman.com/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#007bff', display: 'block' }}
            >
              Terms of Service
            </a>
            <a
              href="https://kaplan.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#007bff', display: 'block' }}
            >
              Privacy Policy
            </a>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;
